import { StyledGradientSpacer } from './styles';

interface GradientSpacerProps {
  variant?: 'top' | 'bottom';
}

const ROTATION_MAP: Record<'top' | 'bottom', number> = {
  top: 0,
  bottom: 180,
};
function GradientSpacer({ variant = 'top' }: GradientSpacerProps) {
  return <StyledGradientSpacer $rotation={ROTATION_MAP[variant]} />;
}

export { GradientSpacer };
